// extracted by mini-css-extract-plugin
export default {"tabContainer":"navtabs_tabContainer__a02Te","selectedTab":"navtabs_selectedTab__TJ7xL","tab":"navtabs_tab__1UB1-","indicator":"navtabs_indicator__98AVN"};